import styled from "styled-components";

export const StyledTitle = styled.div`
  font-family: noto-sans;
  font-weight: bold;
  padding-top: 1vh;
`;
export const StyledSubTitle = styled.div`
  font-family: noto-sans;
  width: 100%;
  height: 13vh;
  padding-right: 5vw;
  margin-left: -1vw;
  font-weight: bold;
  margin-top: 5vh;
`;

export const StyledSubTitle2 = styled.div`
  font-family: noto-sans;
  width: 100%;
  //height: 10vh;
  padding-right: 2vw;
  margin-left: -1vw;
  font-weight: bold;
  margin-top: -1vh;
  margin-bottom: 1vh;
`;

export const StyledSubTitle3 = styled.div`
  font-family: noto-sans;
  width: 100%;
  //height: 13vh;
  padding-right: 2vw;
  margin-left: -1vw;
  font-weight: bold;
  margin-top: 5vh;
  margin-bottom: 5vh;
`;

export const StyledScore = styled.div`
  font-family: noto-sans;
  font-weight: bold;
  text-decoration: underline;
  //padding-top: 5%;
`;

export const StyledImageContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const StyledContainerRow = styled.div`
  margin-top: -40vh;
  z-index: 99;
`;
